import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets scroll position to the top of the page every time
 * the route's pathname changes. Preserves intra-page anchor navigation:
 * if the new URL has a #hash, we scroll to the matching element instead.
 *
 * Mounted once inside <BrowserRouter>. No DOM output.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Honour #anchor links — let the browser scroll to the element with
    // that id, falling back to top if the element doesn't exist yet.
    if (hash) {
      const id = hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    // Disable any in-flight smooth scroll animation so the jump is
    // immediate on both desktop and mobile (iOS Safari respects this).
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
